angular.module('app').directive('apLoginBackground',
    [
        function () {
            'use strict';
        function link(scope, element) {
            element.css('background-image', 'url(images/login-background-clientId-' + scope.clientId + '.jpg), url(images/login-background.jpg)');
        }

        return {
            restrict: 'EA',
            scope: {
                clientId: '=clientId'
            },
            link: link

        };
    }]);